import Flex from '@Components/Bases/Flex';
import { IReport } from '@Domains/Reports';
import { Typography } from '@mui/material';
import CreateReportButton from './CreateReportButton';

type LandingTopicProps = {
  data?: IReport[];
  refetch: () => void;
};

const LandingTopic = ({ data, refetch }: LandingTopicProps) => {
  return (
    <Flex
      justifyContent={'space-between'}
      width={1}
      py={4}
      alignItems={'center'}
    >
      <Typography variant="h3">
        การจัดทำแบบแสดงรายงาน Corporate Value Up
      </Typography>
      {data && data.length !== 0 && <CreateReportButton onSuccess={refetch} />}
    </Flex>
  );
};

export default LandingTopic;
